export default class Pdf {

  createdAt = '';
  id = '';
  name = '';
  type = '';
  status = '';
  customerName = '';

  constructor() {
  }
}
